// short (because we refer to it all over the generated code) but reasonably
// unique
export const globalId = `dt7948`;
